// === Shopify BGN⇄EUR Fixed-Rate Currency Converter v1.3 (Optimized) ===
(function (window, document) {
  'use strict';

  if (window.BgnEurLiveConverter) return;

  const DEFAULTS = {
    fallbackRate: 1.95583,
    selectors: [
      '.price',
      '[class*="price"]',
      '.amount',
      '[class*="amount"]',
      '.cart__price',
      'ins',
      '.cart__price span',
    ],
    batchTime: 50,
    idleDelay: 200,
    debug: false,
    localeBG: 'bg-BG',
    localeEU: 'fr-FR', // Changed for space+comma formatting
    decimals: 2,
  };

  let cfg, rateEURtoBGN, rateBGNtoEUR, observer, enabled;
  const stats = {converted: 0, skipped: 0, errors: 0, lastBatch: 0};
  const seen = new WeakSet();

  // Cache selectors string
  let selectorString = '';

  // Pre-compile regex patterns
  const moneyRE = /(?<!\()([0-9]{1,}(?:[\s.,][0-9]+)*)\s*([€]|лв\.?|BGN|EUR)(?![^()]*\))/gi;
  const alreadyConvertedRE = /\([^)]*(?:€|лв)[^)]*\)/;
  const bgnSymbolRE = /^(?:лв|BGN)$/i;

  // Cache formatters
  let formatterEUR, formatterBGN;

  function log(...args) {
    cfg.debug && console.debug('[BGN⇄EUR]', ...args);
  }

  function initConfig(userCfg = {}) {
    cfg = {...DEFAULTS, ...userCfg};
    selectorString = cfg.selectors.join(',');

    // Pre-create formatters
    formatterEUR = new Intl.NumberFormat(cfg.localeEU, {
      minimumFractionDigits: cfg.decimals,
      maximumFractionDigits: cfg.decimals,
    });
    formatterBGN = new Intl.NumberFormat(cfg.localeBG, {
      minimumFractionDigits: cfg.decimals,
      maximumFractionDigits: cfg.decimals,
    });
  }

  function setFixedRate() {
    rateEURtoBGN = cfg.fallbackRate;
    rateBGNtoEUR = 1 / rateEURtoBGN;
    log('Fixed rate set:', rateEURtoBGN);
  }

  function extractNumber(str) {
    // Remove all non-numeric except comma, dot, dash, space
    let cleaned = str.replace(/[^\d\s,.-]/g, '').trim();

    // Handle space as thousands separator (e.g., "7 980,00")
    if (cleaned.includes(' ')) {
      cleaned = cleaned.replace(/\s/g, '');
    }

    // European format: comma as decimal
    if (cleaned.includes(',') && cleaned.lastIndexOf(',') > cleaned.lastIndexOf('.')) {
      return parseFloat(cleaned.replace(/\./g, '').replace(',', '.'));
    }

    // US format: dot as decimal
    return parseFloat(cleaned.replace(/,/g, ''));
  }

  function format(num, isEUR) {
    return isEUR ? formatterEUR.format(num) : formatterBGN.format(num);
  }

  function replacer(match, amt, sym) {
    const n = extractNumber(match);
    if (isNaN(n) || n <= 0) {
      stats.skipped++;
      return match;
    }

    const isBGN = bgnSymbolRE.test(sym);
    const converted = isBGN ? n * rateBGNtoEUR : n * rateEURtoBGN;
    const label = isBGN ? '€' : 'лв';
    const formatted = format(converted, !isBGN);

    stats.converted++;
    return `<span class="converted">${match} <span class="conversion-pipe">|</span> ${formatted} ${label}</span>`;
  }

  function processBatch(nodes) {
    const start = performance.now();
    let processed = 0;
    const range = document.createRange();

    while (nodes.length && performance.now() - start < cfg.batchTime) {
      const node = nodes.shift();
      if (seen.has(node)) continue;

      const parentEl = node.parentNode;

      // Combined skip check
      if (
        !parentEl ||
        parentEl.tagName === 'DEL' ||
        parentEl.closest('.old-price, .product__price--strike, .converted, .conversion-pipe')
      ) {
        stats.skipped++;
        seen.add(node);
        continue;
      }

      const txt = node.textContent;

      // Quick rejection before regex
      if (!txt || txt.length < 3 || alreadyConvertedRE.test(txt)) continue;

      if (moneyRE.test(txt)) {
        try {
          const html = txt.replace(moneyRE, replacer);
          range.selectNodeContents(node);
          const frag = range.createContextualFragment(html);
          parentEl.replaceChild(frag, node);
          seen.add(node);
          processed++;
        } catch (e) {
          stats.errors++;
          log('Conversion error:', e);
        }
      }
    }

    stats.lastBatch = performance.now() - start;
    return processed;
  }

  function collectTextNodes() {
    const out = [];
    const walker = document.createTreeWalker(document.body, NodeFilter.SHOW_TEXT, {
      acceptNode(node) {
        const nodeValue = node.nodeValue;

        // Quick checks first (fastest to slowest)
        if (!nodeValue || !nodeValue.trim()) return NodeFilter.FILTER_REJECT;

        const parent = node.parentElement;
        if (!parent) return NodeFilter.FILTER_REJECT;

        // Check tag name directly (faster than closest)
        if (parent.tagName === 'DEL') return NodeFilter.FILTER_REJECT;

        // Check if already converted (faster than closest)
        if (parent.classList.contains('converted') || parent.classList.contains('conversion-pipe')) {
          return NodeFilter.FILTER_REJECT;
        }

        // Only use closest for parent selector check (most expensive)
        return node.parentNode.closest(selectorString) ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_SKIP;
      },
    });

    let n;
    while ((n = walker.nextNode())) out.push(n);
    return out;
  }

  function scanAndConvert() {
    if (!enabled) return;
    const nodes = collectTextNodes();
    if (!nodes.length) return;

    (function run() {
      if (!nodes.length) return;
      processBatch(nodes);

      if (nodes.length) {
        ('requestIdleCallback' in window ? requestIdleCallback : setTimeout)(run, cfg.batchTime);
      }
    })();
  }

  function startObserver() {
    if (!('MutationObserver' in window)) return;

    observer = new MutationObserver(() => {
      clearTimeout(observer._timer);
      observer._timer = setTimeout(scanAndConvert, cfg.idleDelay);
    });

    observer.observe(document.body, {childList: true, subtree: true});
  }

  const api = {
    init(options) {
      initConfig(options);
      enabled = true;
      setFixedRate();
      scanAndConvert();
      startObserver();
      log('Converter initialized (fixed rate).');
    },
    pause() {
      enabled = false;
    },
    resume() {
      enabled = true;
      scanAndConvert();
    },
    updateRate(newRate) {
      cfg.fallbackRate = newRate;
      setFixedRate();
    },
    resetStats() {
      stats.converted = stats.skipped = stats.errors = stats.lastBatch = 0;
    },
    getStats() {
      return {...stats};
    },
    disable() {
      this.pause();
      observer?.disconnect();
      log('Converter disabled.');
    },
  };

  window.BgnEurLiveConverter = api;

  document.readyState === 'loading'
    ? document.addEventListener('DOMContentLoaded', () => api.init(), {once: true})
    : api.init();
})(window, document);
